module.exports = __webpack_public_path__ + "static/4invgde-25ee2d3655e82c9fd8b0c6228a447ca8.gif";